import { render, staticRenderFns } from "./DragTree.vue?vue&type=template&id=2fea0d02&"
import script from "./DragTree.vue?vue&type=script&lang=js&"
export * from "./DragTree.vue?vue&type=script&lang=js&"
import style0 from "./DragTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports